module.exports = __webpack_public_path__ + "img/strikethrough_s.20256bf0.svg";